export const SHAPE_FORMS = {
  PLATE: 'PLATE',
  SHEET: 'SHEET',
  RECTANGULAR_BAR: 'RECTANGULAR_BAR',
  HOLLOW_BAR: 'HOLLOW_BAR',
  ROUND_ROD: 'ROUND_ROD',
  CHANNEL: 'CHANNEL',
  I_BEAM: 'I_BEAM',
  SQUARE_BAR: 'SQUARE_BAR',
  ROUND_BAR: 'ROUND_BAR',
  HEXAGONAL_BAR: 'HEXAGONAL_BAR',
  RECTANGULAR_TUBE: 'RECTANGULAR_TUBE',
  SQUARE_TUBE: 'SQUARE_TUBE',
  ROUND_TUBE: 'ROUND_TUBE',
  PIPE: 'PIPE',
  ANGLE: 'ANGLE',
} as const;
